// this file is generated by update_shopify_store_data.py at 2026-06-22 20:31:02.579565
var courses = [
    {
        "course_id": "27B0A603-F451-F011-999A-005056A7F31D",
        "course_version": 1,
        "name": "Essentials of Pediatric Acute Care Orientation",
        "course_type": 32,
        "author_information": "",
        "description": "Developed in collaboration with Pediatric Learning Solutions PACO Advisory Committee and subject matter experts, Essentials of Pediatric Acute Care Orientation (EPACO) uniquely bridges the knowledge gap between what clinicians learn in school and what is expected of them in treating hospitalized children. These CE-approved online modules ensure all orientees receive evidence-based, standardized education with content that is continually reviewed and updated. This comprehensive program engages learners with attractive graphics, illustrations, videos, and photos. Case scenarios and practice activities enhance knowledge transfer and knowledge retention.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EC8BBAFB-2E51-F011-9998-005056A730AF",
                "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "FF3C3B5F-D91C-E811-8740-005056B12710",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Adolescents",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the adolescent from 12 to 19 years of age. The physical, cognitive and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to each adolescent. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the adolescent.</li>\r\n    <li>Identify the physiologic and developmental characteristics of the adolescent.</li>\r\n    <li>Describe the adolescents age-specific needs applied to your daily practice.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BD7EFE29-7923-E811-893D-005056B17124",
                "course_version": 3,
                "name": "PLS - EPACO: Basic Medication Calculation",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Health care practitioners have an important role in medication calculation. They must not only perform accurate medication calculations themselves, but also confirm the accuracy of calculations made by colleagues. It is essential that each clinician who has responsibility for ordering, dispensing and/or administering medication is competent in medication calculation. This course provides a review of basic medication calculation including measurement, conversions and dosage calculations. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify common sources of error in medication calculation and related strategies for safe medication delivery.</li>\r\n    <li>Review common conversions and accurately convert simple measurements from one system of weight and measure to another.</li>\r\n    <li>Demonstrate accurate dosage calculation utilizing appropriate methods and rounding guidelines for pediatrics.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "61D4A402-7923-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for School-Age Children",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the school-age child from 6 years up to 12 years of age. The physical, cognitive, and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to each school-age child. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the school-ager.</li>\r\n    <li>Identify the physiologic and developmental characteristics of the school-age child.</li>\r\n    <li>Describe the age-specific needs of the school-age child applied to your daily practice.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "0621A911-7923-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Toddlers",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the toddler from 12 months to 36 months. The physical, cognitive, and psychosocial needs of the patient and family are discussed. By understanding and incorporating knowledge into your daily practice, you will be more effective in providing competent care to each toddler. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the toddler.</li>\r\n    <li>Identify the physiologic and developmental characteristics of the toddler.</li>\r\n    <li>Describe the toddler's age-specific needs applied to your daily practice.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E17BD0AF-7823-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Adults",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development of the adult patient. For the purposes of this course, \"adult\" is defined as patients 19 years of age and older. By understanding and incorporating the physical, cognitive and psychosocial needs of the adult patient and family into daily practice, the health care team will be more effective in providing competent care to this patient population. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss growth and developmental considerations of the adult.</li>\r\n    <li>Identify age-specific physiologic and developmental characteristics of the adult.</li>\r\n    <li>Describe age-specific modifications for providing care to the adult patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "055592C7-7823-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Infants",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the infant, from 29 days to 12 months. The physical, cognitive, communication and psychosocial needs of the infant and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to the infant population. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain how to provide individualized care based on the developmental needs of the patient/family member.</li>\r\n    <li>State a major developmental consideration and age-specific care issue for the infant 29 days to 12 months old.</li>\r\n    <li>Explain how to incorporate your knowledge of an infant's age-specific needs into your daily practice.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E1564EDE-7823-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Newborns",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the newborn infant, from birth to 28 days including high-risk neonates. The physical, cognitive and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to each infant. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss developmental considerations and age-specific care of the newborn.</li>\r\n    <li>Identify the physiologic and developmental characteristics of the neonate including the high-risk neonate.</li>\r\n    <li>Describe the newborn infant's age-specific needs applied to your daily practice.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8369A9EE-7823-E811-BEE8-005056B1633E",
                "course_version": 3,
                "name": "PLS - EPACO: Age-Specific Care for Preschoolers",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of age-specific growth and development for the preschooler from 3 years of age up to 6 years. The physical, cognitive and psychosocial needs of the patient and family are discussed. By understanding and incorporating this knowledge into your daily practice, you will be more effective in providing competent care to preschoolers. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.25]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to: </p>\r\n<ul>\r\n    <li>\r\n    Discuss developmental considerations and age-specific care of the preschooler.\r\n    </li>\r\n    <li>Identify the physiologic and developmental characteristics of the preschooler.\r\n    </li>\r\n    <li>Describe the preschoolers age-specific needs applied to your daily practice.\r\n    </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.25 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1B3FDD1B-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Child Abuse and Neglect",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Child abuse is a serious threat to the health, safety and well-being of children in this country. It is a sensitive issue that requires careful assessment by healthcare providers. This course discusses the types of child abuse and neglect, including human trafficking, the related indicators and the reporting responsibilities of healthcare providers. Review details within the body of this course to validate availability of CE credits.  [CNE (ANCC) 1] [CME (ACCME) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain the most common types of child abuse.</li>\r\n    <li>Outline risks and protective factors for child abuse and neglect.</li>\r\n    <li>Identify possible indicators of sexual abuse and human trafficking.</li>\r\n    <li>Distinguish cultural health practices and conditions that may be confused with abuse when assessing a child for potential maltreatment.</li>\r\n    <li>Recognize individuals who are mandated reporters and discuss the responsibilities of reporting child maltreatment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DBD416CA-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Preventing Pediatric Falls",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The Institute of Medicine has identified falls, both adult and pediatric, as a significant patient safety risk. In order to reduce falls, organizations are required to have a fall reduction program that includes individualized strategies for patients. Staff members, patients and caregivers should all be educated on ways to reduce falls. The content of this course aligns with the standard prevention elements outlined by the Children\u2019s Hospitals\u2019 Solutions for Patient Safety (SPS)Prevention Bundles. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Summarize the unique characteristics of falls in the pediatric population.</li>\r\n    <li>Outline assessment parameters for fall risk.</li>\r\n    <li>Implement fall prevention strategies for pediatric patients.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6E1DE5DE-8C23-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Management of Peripheral IV Complications in the Pediatric Patient",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Peripheral intravenous lines(PIVs)play an important role in the treatment of many clinical conditions of the pediatric patient. However, PIVs are not without potential complications. This course provides an overview of PIV assessment and management, including recognition of abnormal PIV assessment findings, identification of the types of PIV complications and the prevention and management of complications. Rapid recognition of complications and appropriate interventions are important in limiting negative patient outcomes. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify assessment findings of the PIV that indicate a complication.</li>\r\n    <li>Describe appropriate interventions and follow-up actions for each identified PIV complication.</li>\r\n    <li>Discuss guidelines for preventing PIV complications.</li>\r\n    <li>Describe documentation of PIV assessment and use of evidence-based assessment scales.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B716E8A2-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Medication Error Reduction",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Various studies have found the delivery of a single dose of medicine requires between 10 and 15 steps, thus making medication delivery an error-prone process. This course discusses the incidence of medication errors and current regulatory standards and identifies prevention strategies used to support a culture of high reliability and to reduce errors. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify phases of the medication administration process where pediatric patients are at increased risk of harm from medication errors.</li>\r\n    <li>Examine sources and types of medication errors.</li>\r\n    <li>Recognize the importance of identifying and reporting medication errors.</li>\r\n    <li>Examine strategies to reduce or prevent medication errors that support a culture of high reliability and safety.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.5 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "DCD4A9D2-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pain Management: Pain Pathophysiology",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pain affects most pediatric patients at some point during their care. For the health care team, understanding the pathophysiology of pain is essential for proper identification and treatment. This course provides an overview of the types of pain and the underlying pathophysiology, and it examines how pain-management techniques can merge the understanding of both. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Differentiate between acute and chronic pain.</li>\r\n    <li>Recognize the pathophysiology of how the body senses and processes pain.</li>\r\n    <li>Describe the characteristics of nociceptive pain.</li>\r\n    <li>Define the unique characteristics of neuropathic pain.</li>\r\n    <li>Explain the various pharmacologic and non-pharmacologic methods for treating pain based on pain pathophysiology.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.5 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E721EAE8-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pain Management: Pharmacological Management of Pediatric Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course discusses the pharmacological management of pain in children. Analgesics are discussed, including the different medication classes and their role in achieving adequate pain control. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define key pharmacology concepts associated with pain control.</li>\r\n    <li>State the indications, mechanism of action and the most common adverse effects of non-opioids, opioids and adjuvants for pain management.</li>\r\n    <li>Differentiate between tolerance, dependence, withdrawal and addiction.</li>\r\n    <li>Recognize the importance of anticipatory guidance for families with children receiving opioid pain medication.</li>\r\n    <li>Describe how to safely dispose of opioid medications.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AD59C428-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Gastrointestinal System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "It is vital that health care providers develop exceptional skills in a gastrointestinal(GI)health assessment and physical exam. GI symptoms can be extremely subjective due to the variation in definitions of symptoms such as diarrhea and constipation. This course describes the skills and knowledge required to perform a comprehensive pediatric GI history and physical assessment as well as the ability to determine normal and abnormal findings. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the components of a gastrointestinal(GI)history specific to the pediatric patient.</li>\r\n    <li>Discuss age and development-appropriate components of the pediatric GI and nutritional assessment and physical exam.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric GI physical exam.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "6F700D9F-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Nutritional Overview",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Nutrition is an important part of the well-being of pediatric patients at all stages of development, and can be impacted by illness, both acute and chronic. Similarly, the nutrition state in which a child arrives into your care can impact the child\u2019s recovery time and overall outcomes. All clinicians can improve outcomes by considering and implementing optimal nutrition during a child\u2019s hospital stay. This course will discuss the specific nutritional needs of each of these age groups: Infant, Toddler, Preschool, School-age, Adolescent\r\n\r\nPediatric Registered Dietitian Consult \r\nA registered dietitian should be consulted for advanced nutrition care including specialized medical nutrition therapy, detailed nutrition assessments, assessing growth trends, and determining individual calorie/protein/fluid needs.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss assessment of adequate nutrition including age-specific energy and nutrient needs.</li>\r\n    <li>Describe guidelines for age-appropriate formula and/or food choices.</li>\r\n    <li>Discuss indications for oral supplementation, enteral nutrition and parenteral nutrition.</li>\r\n    <li>Describe behavioral and lifestyle interventions for childhood obesity prevention and treatment.</li>\r\n    <li>Identify risk factors and screening methods for malnutrition in the pediatric patient.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for&nbsp;1.00 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4117D5C3-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pain Management: Non-Pharmacological Therapies in the Management of Pediatric Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Non-pharmacological therapies, used in conjunction with pharmacological interventions, can be used to successfully manage children\u2019s pain. This course outlines non-pharmacologic pain-management options, including developmentally appropriate pain-management strategies. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Explain the pain pathway and the role non-pharmacological therapies can have in disrupting that pathway.</li>\r\n    <li>Illustrate the importance of caregiver presence, preparation and positioning for comfort as strategies for pain management.</li>\r\n    <li>Differentiate non-pharmacological therapy strategies from the sensory, cognitive/behavioral and imagery categories.</li>\r\n    <li>Identify developmentally appropriate non-pharmacological therapies for infants, toddlers, preschoolers, school-aged children and adolescents.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A3104A1A-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Cardiovascular System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course reviews the components of a cardiovascular(CV)assessment in children. While most children have healthy hearts, cardiac conditions in the pediatric patient can be subtle and can go undiagnosed for a period of time. Therefore, it is important to routinely complete a systematic cardiovascular assessment. Completing a thorough CV assessment may also identify risk factors for adult heart disease and allow the clinician to encourage lifestyle changes to promote positive health outcomes. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Outline the components of the cardiovascular history and physical exam of the pediatric patient.</li>\r\n    <li>Identify normal and abnormal findings of the cardiovascular assessment.</li>\r\n    <li>Develop a systematic approach to assessing heart sounds and differentiating murmurs that may be associated with cardiac defects.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4BA7F15F-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Musculoskeletal System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Early detection and treatment of musculoskeletal disorders and skeletal deformities may prolong function and prevent complications. This course discusses the assessment skills necessary to identify abnormalities in a pediatric musculoskeletal exam. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify components of the musculoskeletal system history specific to the pediatric patient.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric musculoskeletal exam and associated conditions.</li>\r\n    <li>Identify essentials of the post-surgical orthopedic assessment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D51F3BB1-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Peripheral IV Care & Management",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The peripheral intravenous catheter(PIV)is the most commonly used intravenous device in hospitalized patients. Although PIVs are considered low risk, there can be complications resulting in serious harm. Clinicians should follow the standard of care to protect patients from potential injuries. This course provides an overview of PIV care, including comfort measures, device selection, insertion and securement techniques and assessment parameters. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Select the appropriate access device based on length of therapy, type of fluids and patient history.</li>\r\n    <li>Describe correct peripheral IV insertion techniques to reduce risks for complications, including infiltration and extravasation.</li>\r\n    <li>Identify PIV securement techniques that promote visualization and stabilization of site.</li>\r\n    <li>Outline assessment parameters used when monitoring PIV sites.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "27CFF6E1-9223-E811-AAA9-005056B1689B",
                "course_version": 4,
                "name": "PLS - EPACO: Pressure Injury Staging Assessment",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This assessment provides staff members the opportunity to practice and verify accuracy in identifying pressure injury stages. Enhanced competency in accurately staging pressure injuries will assist in providing appropriate management strategies.\r\n\r\nEach test question will have a photograph and description of a pressure injury. Stage each pressure injury in accordance with the National Pressure Injury Advisory Panel's (NPIAP)staging guidelines.\r\n\r\nAdditional Courses \r\nAdditional Pediatric Learning Solutions courses* you may find helpful:\r\nPediatric Assessment: The Integumentary System\r\nIntroduction to Pressure Injuries in the Pediatric Population\r\nPressure Injuries in the Pediatric Population: Staging and Care\r\n\r\n*Note: This module may not be currently available in your organization.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (JAICE) Credits: 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Accurately stage pressure injury images using the 2019 NPIAP staging guidelines.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8161C1DD-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Therapeutic Relationships and Professional Behavior",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The National Council of State Boards of Nursing(NCSBN)states that a \u201ctherapeutic nurse-patient relationship protects the patient\u2019s dignity, autonomy and privacy and allows for the development of trust and respect.\u201d The complexity of the health care environment can make it challenging to establish therapeutic relationships with pediatric patients and families. This module will identify the characteristics of a professional, therapeutic clinician-patient relationship as well as strategies for identifying and avoiding inappropriate behaviors and relationships. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5] [CME (ACCME) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe therapeutic relationships between health care providers and those under their care, including the phases of developing a relationship.</li>\r\n    <li>Discuss the continuum of professional behavior and consequences of boundary crossings and boundary violations.</li>\r\n    <li>Recall professional obligations required of the health care professional when participating in social media networking.</li>\r\n    <li>Identify behaviors with patients and families that reflect the concepts of therapeutic relationships, boundary crossings and boundary violations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "38BA9C8E-8C23-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Clinical Delegation",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Clinical delegation is a critical component for the health care team working collaboratively to provide quality patient care. Organizational cost-containment strategies, vacant positions, high patient census, increased patient acuity and demographic changes have contributed to the increasing use of assistive personnel in health care settings. This course will help clinicians develop the delegation skills necessary to coordinate and deliver safe, efficient patient care among a health care team that includes assistive personnel. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define clinical delegation.</li>\r\n    <li>Describe the importance of appropriate clinical delegation.</li>\r\n    <li>Discuss roles and responsibilities related to clinical delegation.</li>\r\n    <li>Identify strategies to overcome barriers to delegation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FD7DCDB1-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pain Management: Assessment of Pain",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Evidence-based pain intervention can significantly reduce patient distress, improve the patient experience and help guide care. Pain assessment is the foundation of effective pain management. This course will review the elements of a complete pain assessment, pain intensity scales and the role of clinical judgment in managing patients\u2019 pain effectively. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify assessment findings that may indicate pain in the pediatric patient and developmentally disabled pediatric patient.</li>\r\n    <li>State the elements to consider in a pain assessment.</li>\r\n    <li>Describe the pain intensity scales commonly used in assessing children of various levels of development and function.</li>\r\n    <li>Delineate accreditation standards for pain assessment and management.</li>\r\n    <li>Discuss the role of critical judgment in assessing and managing pain.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "FDE887F9-9123-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pain Technologies: PCA & Epidural Analgesia",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course discusses the use of patient-controlled analgesia(PCA)and epidural analgesia as methods to provide pediatric pain management safely and effectively. Specifically discussed are advantages and disadvantages of each, patient selection criteria, common medications used, patient assessment and monitoring and corresponding nursing interventions. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>State the advantages and disadvantages of PCA and epidural analgesia.</li>\r\n    <li>Identify patients that are appropriate candidates for PCA or epidural analgesia.</li>\r\n    <li>Discuss medications commonly used for PCA and epidural analgesia.</li>\r\n    <li>Describe appropriate nursing assessments and monitoring, corresponding nursing interventions, documentation and patient/family education for PCA and epidural analgesia.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2148338B-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Respiratory System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Respiratory symptoms are one of the most common reasons for an outpatient visit and inpatient admission in pediatrics. Because of this, the skills required for the pediatric respiratory exam are some of the most important when assessing the pediatric patient. This course reviews the key components necessary to provide a thorough pediatric respiratory exam. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss key elements of a complete history of respiratory illnesses and thorough respiratory assessment.</li>\r\n    <li>Describe clinical manifestations of various respiratory illnesses seen in pediatric patients.</li>\r\n    <li>Recall important signs and symptoms to document as part of the respiratory system assessment.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C83FB982-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Intimate Partner Violence",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Intimate partner violence (IPV), also known as domestic violence, is a serious and widespread public health issue. All health care providers, including those working in pediatric settings, must be sensitive to this issue and should carefully and routinely assess patients and family members for signs of violence. This course discusses the prevalence of intimate partner violence, types and indicators of abuse, impact on children, and the related responsibilities of health care providers. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define intimate partner violence.</li>\r\n    <li>Explain key elements, signs and symptoms and types of intimate partner violence.</li>\r\n    <li>Describe the impact of intimate partner violence on children.</li>\r\n    <li>Outline health care provider responsibilities related to screening, intervention, documentation and reporting of intimate partner violence.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "65502398-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Introduction to Ethics",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Navigating ethical issues in clinical settings is not easy, especially in pediatric acute care facilities. Differing values among stakeholders, along with rapid technological advances, can make deciding what is \"right\" or \"wrong\" for an individual patient challenging. This course will examine moral dilemmas, offer tools to analyze and work through difficult cases, and discuss resources available to clinicians. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe situations in pediatric facilities that may create ethical issues.</li>\r\n    <li>Discuss core ethical values that may influence medical decision making.</li>\r\n    <li>Apply ethical decision-making frameworks.</li>\r\n    <li>Recognize situations that might require other resources, such as an ethics consultation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1F8862AD-8723-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Restraints and Seclusion",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The use of restraints and seclusion is sometimes necessary for the safety of the patient and staff. However, because there can be risks associated with their use, it is important for the clinician to be familiar with guidelines and safety measures that should be taken when using restraints. This course reviews the Centers for Medicare and Medicaid Services (CMS), The Joint Commission (TJC) and National Integrated Accreditation for Healthcare Organizations (NIAHO\u00ae; aka DNV) standards and practice guidelines for the use of restraint and seclusion in the hospital setting. Your state legislature may also have written standards. These standards are designed to protect the patient. \r\n\r\nNote for Behavioral Health Clinicians: This course does not discuss the restraint and seclusion standards specific to the behavioral health care setting. Refer to your organization's policies specific to behavioral health care units and/or CMS's, TJC's or NIAHO's specific accreditation manual (e.g., TJC Comprehensive Manual for Behavioral Health Care), as it applies to your setting.\r\n\r\nReview details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1] [CME (ACCME) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define hospital-setting restraint and seclusion and differentiate from interventions that are not considered restraint.</li>\r\n    <li>Differentiate the purpose and standards of practice for each type of restraint and seclusion.</li>\r\n    <li>Outline the Centers for Medicare and Medicaid Services(CMS), The Joint Commission(TJC)and National Integrated Accreditation for Healthcare Organizations(NIAHO&reg;)standards related to restraint and seclusion use in the hospital setting.</li>\r\n    <li>Identify alternatives to restraint and seclusion.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1400ED9C-78EE-EC11-80F3-005056B17FCD",
                        "course_category_name": "Parent: PLS - EPACO (ANCC Credit)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "zRemoved-Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8AAA08E8-BD1D-E011-99B6-0015171C1A75",
                        "course_category_name": "Other Credit Units",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F18CF3B0-8C23-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Health Care Advance Directives: Communicating Wishes",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Advance directives are legal documents that patients use to convey their wishes about end-of-life care if they should become unable to communicate or make decisions for themselves. If a health care advance directive has been completed by the patient, then health care providers have the legal responsibility to obtain a copy of the document and follow the patient\u2019s wishes. This course reviews the types of advance directives patients may have, advance care planning options for minor patients, the responsibility of health care providers, and potential problems encountered when working with a patient with an advance directive. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5] [CME (ACCME) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe the purpose and importance of an advance directive.</li>\r\n    <li>Compare and contrast types of advance directives.</li>\r\n    <li>Discuss advance care planning options for minor patients.</li>\r\n    <li>Outline health care providers&rsquo; responsibilities related to advance directives.</li>\r\n    <li>Identify common problems encountered when following an advance directive.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ACCME; ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ACCME; ANCC",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3928DEC6-8C23-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: High-Alert Medications",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "This course provides an overview of high-alert medications, including the definition of \"high-alert\" and specific high-alert medications. Common risk factors and strategies to prevent harm and reduce medication errors are also discussed. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Define high-alert medications. Discuss the high-alert medications identified by the Institute for Safe Medication Practices (ISMP).</li>\r\n    <li>Recognize common risk factors and suggested strategies to reduce errors related to high-alert medications.</li>\r\n    <li>Identify &ldquo;just culture&rdquo; behaviors relative to the administration of high-alert medications and patient safety.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "5F982DD5-8C23-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Introduction to Pediatric Pressure Injury",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Though the majority of pressure injury research involves the adult population, pressure injuries also affect infants and children. It is important for all members of the health care team to understand the factors involved in pressure injury development and how to prevent them from occurring in at-risk neonatal and pediatric patients. This course includes a review of normal skin anatomy and introduces the risk factors and risk assessment of pressure injury development in the pediatric population as well as related prevention strategies. The content of this course aligns with the Children\u2019s Hospitals\u2019 Solutions for Patient Safety (SPS)prevention and maintenance bundles. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify characteristics for each stage of pressure injuries.</li>\r\n    <li>Recognize common locations and medical devices associated with pressure injury development.</li>\r\n    <li>Use a risk-assessment tool such as the Braden QD scale to assess for risk factors of developing a pressure injury.</li>\r\n    <li>Implement intervention strategies to reduce risk of pressure injury development.</li>\r\n    <li>Accurately distinguish a Stage 1 pressure injury.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D7722A0A-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: Performing a Head-to-Toe Assessment",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "A systemic head-to-toe assessment, based on the age of the patient, supports a thorough and efficient exam. If a patient shows physical signs or reports problems with a specific body system, a more thorough assessment should be performed. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Discuss the developmental approach to the pediatric head-to-toe assessment.</li>\r\n    <li>Recognize normal vital sign values and growth parameters.</li>\r\n    <li>Describe the detail and sequence of a head-to-toe assessment based on the child&rsquo;s age and developmental level.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "096E213D-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Genitourinary System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Assessment of the genitourinary system provides valuable information about a patient\u2019s health. However, families and patients, especially adolescents, may be uncomfortable discussing genitourinary symptoms. Health care providers must be competent and sensitive both in obtaining a complete history, and in performing a thorough physical genitourinary assessment. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Demonstrate a focused review of current genitourinary symptoms as well as medical and family history while maintaining sensitivity and privacy.</li>\r\n    <li>Outline the essential components of a genitourinary assessment in pediatric patients.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric genitourinary exam.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "E797454F-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Integumentary System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "The integumentary system consists of the skin, hair, nails, glands and nerves. Its main function is to be a barrier that protects the body from the outside world, including chemicals, ultraviolet rays, and microbes. It also functions to retain body fluids, eliminate waste products and regulate temperature. This course reviews the assessment skills necessary to identify abnormalities of the integumentary system in children. There is a wide variation in the presentation and treatment of conditions. Therefore, accurate assessment, including a detailed history and physical exam, is extremely important. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 1]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Describe a complete skin assessment and necessary documentation for the pediatric patient.</li>\r\n    <li>Identify normal and frequently seen abnormal findings in the pediatric integumentary exam.</li>\r\n    <li>Discuss presentation of common disorders of the pediatric integumentary system.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 1 contact hour. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "1F364574-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pediatric Assessment: The Neurological System",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Neurological dysfunction can manifest in almost any body system and may be challenging to diagnose, particularly in infants. A thorough neurological assessment aids in the proper diagnosis and treatment of neurological disease or injury. Neurological injury can result due to trauma, toxins, infection, degeneration, structural defects, tumors, blood flow changes, immune disorders and genetic or metabolic issues. This course reviews the key components of a systematic pediatric neurological exam. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.75]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify the components of the neurological system assessment specific to the pediatric patient.</li>\r\n    <li>Describe normal and abnormal findings of the pediatric neurological exam.</li>\r\n    <li>Identify associated findings of a patient with suspected brain injury.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.75 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "93959AC5-9223-E811-AAA9-005056B1689B",
                "course_version": 3,
                "name": "PLS - EPACO: Pressure Injuries in the Pediatric Population: Staging and Care",
                "course_type": 1,
                "author_information": "See each module's Course Information page.",
                "description": "Pressure injuries do occur in the pediatric population. Pressure injuries can cause considerable harm and may result in increased length of stay, infection, surgical intervention and sepsis. It is imperative that health care providers know how to accurately assess and stage pressure injuries and to be able to provide appropriate wound care management in order to prevent further injury. This course introduces the learner to the assessment and staging of pressure injuries utilizing the revised National Pressure Injury Advisory Panel (NPIAP)pressure injury staging system. The course reviews the differences between pressure injuries and other types of wounds and reviews wound care management strategies. Additionally, CHA has aligned this content with the Children's Hospitals' Solutions for Patient Safety (SPS) Prevention Bundle to ensure it represents current evidence-based practice. Review details within the body of this course to validate availability of CE credits. [CNE (ANCC) 0.5]",
                "learning_objectives_html": "<p>At the conclusion, participants should be able to:</p>\r\n<ul>\r\n    <li>Identify pressure injury stages, including unstageable pressure injuries and deep tissue injury(DTI), using the National Pressure Injury Advisory Panel (NPIAP)standards.</li>\r\n    <li>Discuss the elements required to thoroughly document pressure injuries.</li>\r\n    <li>Differentiate pressure injuries from other wound types.</li>\r\n    <li>Describe key interventions when caring and managing pressure injuries.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                        "course_category_name": "Pediatric Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E48BBAFB-2E51-F011-9998-005056A730AF",
                        "course_category_name": "PLS - Pediatric Learning Solution - Essentials of Pediatric Acute Care Orientation - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DB13DF00-D91C-E811-8740-005056B12710",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6DF5C2BC-B67B-DF11-93F1-00188B39EB5C",
                        "course_category_name": "Pediatric Learning Solutions, a division of Children\u2019s Hospital Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "15042364-D61C-E811-8806-005056B10652",
                        "course_category_name": "PLS - Pediatric Learning Solutions - Essentials of Pediatric Acute Care Orientation",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "This offering has been accredited for 0.50 contact hours. Learners must complete the post-assessment and evaluation associated with this online module to be awarded contact hours. Approval of the continuing education activity does not imply endorsement by Children's Hospital Association, CHCA or ANCC of any commercial products displayed in conjunction with this activity. Children's Hospital Association has a conflict of interest policy that requires faculty to disclose relevant financial relationships related to the content of their presentations/materials. Any potential conflicts are resolved so that presentations are evidence-based and scientifically balanced. The planning committee members and all speakers/presenters/authors have declared no conflict of interest.",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];